import { useActiveWorkspace } from '@/true-fsd/data/advertiser-account/hooks'
import {
    InviteLinksGroupsSitesWidget,
    InviteLinksGroupsChannelsWidget,
} from '@/widgets/analytics'

export const LinksGroupsPage = () => {
    const { activeWorkspace } = useActiveWorkspace()

    if (activeWorkspace.workspace_type === 'site') {
        return <InviteLinksGroupsSitesWidget siteId={activeWorkspace.site_id} />
    } else {
        return (
            <InviteLinksGroupsChannelsWidget
                channelId={activeWorkspace.channel_id}
            />
        )
    }
}
